"use client";
import React from "react";
import { useTranslation } from "react-i18next";

import {
  PreviewLinks,
  PreviewPdf,
  PreviewUrl,
  PreviewApps,
  PreviewImages,
  PreviewVideo,
  PreviewWifi,
  PreviewYoutube,
  PreviewWebsite,
  PreviewBusiness,
  PreviewVcard,
  PreviewSocial,
  PreviewEvent,
  PreviewCoupon,
  PreviewFeedback,
  PreviewMp3,
  PreviewText,
  PreviewEmail,
  PreviewUrlStatic,
  PreviewSMS,
  PreviewWhatsapp,
} from "@/components/previews";

import { QRViewPageTemplateProps } from "./types";
import "./styles.scss";

export const QRViewPageTemplate = ({ qrData, language }: QRViewPageTemplateProps) => {
  const qrType = qrData?.type || "";

  const { i18n } = useTranslation();
  const allResources = i18n.options.resources[language];

  const previews = {
    website: PreviewWebsite,
    listoflinks: PreviewLinks,
    pdf: PreviewPdf,
    url: PreviewUrl,
    apps: PreviewApps,
    business: PreviewBusiness,
    image: PreviewImages,
    video: PreviewVideo,
    wifi: PreviewWifi,
    youtube: PreviewYoutube,
    vcard: PreviewVcard,
    social: PreviewSocial,
    event: PreviewEvent,
    coupon: PreviewCoupon,
    feedback: PreviewFeedback,
    mp3: PreviewMp3,
    text: PreviewText,
    email: PreviewEmail,
    ["url-static"]: PreviewUrlStatic,
    sms: PreviewSMS,
    whatsapp: PreviewWhatsapp,
  };

  const Empty = () => <div></div>;
  const Component = previews[qrType] || Empty;
  const preview = !(
    qrType === "url" ||
    qrType === "wifi" ||
    qrType === "image" ||
    qrType === "text" ||
    qrType === "whatsapp"
  );

  return (
    <div className="QRCodePage">
      <Component
        {...qrData}
        previewTranslations={allResources}
        preview={preview}
        source={"preview-page"}
      />
    </div>
  );
};
